var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column"},[_c('SidebarItem',{staticClass:"order-md-0 order-3",attrs:{"text":"Downloads","to":"/aluno"},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('use',{attrs:{"xlink:href":"#icon-download"}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }